import {
    ADD_COUNTRIES,
    ADD_TIMEZONES,
    ADD_LANGUAGES,
    ENQUEUE_SNACKBAR,
    REMOVE_SNACKBAR,
    SET_IS_NANO,
    SET_HAS_SETUP
} from '../actions/appActionTypes';
import { LOG_OUT } from '../../auth/actions/authActionTypes';
import { addNotification, removeNotification } from './helpers';

const initialState = {
    Countries: [],
    Timezones: [],
    Languages: [],
    isNano: false,
    hasSetup: false,
    notifications: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case ENQUEUE_SNACKBAR:
            return {
                ...state,
                notifications: addNotification(state, action.payload.notification)
            };
        case REMOVE_SNACKBAR:
            return {
                ...state,
                notifications: removeNotification(state, action.payload.key)
            };
        case ADD_COUNTRIES:
            return {
                ...state,
                Countries: action.payload.Countries
            };
        case ADD_TIMEZONES:
            return {
                ...state,
                Timezones: action.payload.Timezones
            };
        case ADD_LANGUAGES:
            return {
                ...state,
                Languages: action.payload.Languages
            };
        case SET_IS_NANO: {
            return {
                ...state,
                isNano: action.payload.isNano
            };
        }
        case SET_HAS_SETUP: {
            return {
                ...state,
                hasSetup: action.payload.hasSetup
            };
        }
        case LOG_OUT: return initialState;
        default: return state;
    }
};
